<div class="cm-table__filter-row" *ngIf="column$ | async as col">
	<mat-form-field *ngIf="col.filter as filter" [formGroup]="form">
		<mat-label>
			<span [cmLocalize]="filter.localizationKey" [default]="filter.label"></span>
		</mat-label>
		<mat-select formControlName="filter" multiple (selectionChange)="toggleFilter(col.filterField, $event.value)"
			panelClass="cm-table-filter-select-panel">
			<mat-option *ngFor="let option of filter.options" [value]="option">
				<ng-container *ngIf="!!option; else noValue">
					{{ option }}
				</ng-container>
			</mat-option>
		</mat-select>
	</mat-form-field>

	<button mat-button cm-mini-button [attr.aria-label]="'Clear' | cmLocalize: 'Core/System.Table.Button.ClearSearch'"
		[matTooltip]="'Clear' | cmLocalize: 'Core/System.Table.Button.ClearSearch'" (click)="clear()"
		*ngIf="showClear$ | async">
		<ats-icon [size]="12" name="close"></ats-icon>
	</button>
</div>

<ng-template #noValue>
	<span [cmLocalize]="locFeature + '/System.Global.MenuItem.NoValue'">
		No Value
	</span>
</ng-template>
